var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-label"},[(_vm.isText)?_c('span',[_vm._v(" "+_vm._s(_vm.showText)+" ")]):_vm._e(),(_vm.isHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.showText)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }